import { getStatusLabel } from '@shared/status-labels';

import { cn } from '../ui/utils';

export type ReportContext = 'purchaseOrder' | 'salesOrder' | 'picking' | 'receiving' | 'warning' | 'bill' | 'lot';

export type StatusBadgeProps = {
  status?: string;
  context?: ReportContext;
  className?: string;
  size?: 'small' | 'medium';
};

const successStatuses = new Set([
  'SUBMITTED',
  'APPROVED',
  'OPEN',
  'PAYMENT_RECONCILIATION',
  'PAID_FULL',
  'PAID',
  'FINALIZED',
  'INVOICED',
  'READY',
  'FULLY_PICKED',
  'FULLY_RECEIVED',
  'COMPLETE',
  'PRINTED',
]);
const infoStatuses = new Set(['PICKING', 'RECEIVING', 'CONFIRMED', 'EN_ROUTE', 'MID_RECEIVING']);
const warningStatuses = new Set([
  'SHIPPED',
  'IN_TRANSIT',
  'PENDING_LIQUIDATION',
  'IN_PROGRESS',
  'MID_PRODUCTION_RUN',
  'RECEIVED',
  'PARTIALLY_PICKED',
  'PARTIALLY_RECEIVED',
  'PENDING_SETTLEMENT',
  'BOOKED',
  'PAID_PARTIAL',
]);
const errorStatuses = new Set([
  'CANCELLED',
  'VOIDED',
  'NOT_STARTED',
  'LOCKED',
  'PROCESSING_ERROR',
  'ERROR',
  'REJECTED',
]);

export function getStatusColor(status: string, context?: ReportContext | 'salesOrder' | 'purchaseOrder') {
  if (status === 'NEEDS_INFO') return context === 'purchaseOrder' ? 'badge-red' : 'badge-blue';
  if (status === 'PICKING' && context === 'warning') return 'badge-orange';
  if (successStatuses.has(status)) return 'badge-green';
  if (infoStatuses.has(status)) return 'badge-blue';
  if (warningStatuses.has(status)) return 'badge-orange';
  if (errorStatuses.has(status)) return 'badge-red';
  return '';
}

export default function StatusBadge({ status, context, size = 'medium', className }: StatusBadgeProps) {
  if (!status) return null;

  const label = getStatusLabel(status);

  return (
    <span
      id="status-badge"
      className={cn('badge', size === 'medium' && 'badge-lg', getStatusColor(status, context), className)}
    >
      {label}
    </span>
  );
}
